import Autocomplete, {
  AutocompleteRenderInputParams,
} from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SingleSelectWithSearchProps } from 'components/Shared/SingleSelectWithSearch/SingleSelectWithSearchProps'

const SingleSelectWithSearch = <T,>(props: SingleSelectWithSearchProps<T>) => {
  const {
    options = [],
    defaultValue = null,
    getOptionLabel,
    isOptionEqualToValue,
    onInputChange,
    onChange,
    loading,
    TextFieldParams,
    readOnly,
    value,
    onBlur,
    onFocus,
  } = props

  // this is to render loader in the input box only when the loading prop is included in the component which uses this generic component
  const showLoader = 'loading' in props

  const { t } = useTranslation()

  const renderInput = (params: AutocompleteRenderInputParams) => {
    return (
      <TextField
        {...params}
        fullWidth={TextFieldParams.fullWidth}
        variant={TextFieldParams.variant}
        data-testid={TextFieldParams.testId}
        helperText={TextFieldParams.helperText}
        error={TextFieldParams.error}
        InputProps={{
          ...params.InputProps,
          endAdornment: showLoader && (
            <React.Fragment>
              {loading ? (
                <CircularProgress
                  data-testid="circular-progress"
                  color="inherit"
                  size={20}
                />
              ) : null}
              {params.InputProps.endAdornment}
            </React.Fragment>
          ),
        }}
      />
    )
  }
  return (
    <Autocomplete
      options={options}
      defaultValue={defaultValue}
      value={value}
      onFocus={onFocus}
      renderInput={renderInput}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      onInputChange={onInputChange}
      filterOptions={(x) => x}
      onChange={onChange}
      readOnly={readOnly}
      noOptionsText={t('common.noOptions')}
      onBlur={onBlur}
      blurOnSelect
    />
  )
}

export default SingleSelectWithSearch
